/* Falaq buyer helpers: delivery date estimate and US ring size finder. */
(function () {
  function muscatNow() {
    var d = new Date();
    return new Date(d.getTime() + d.getTimezoneOffset() * 60000 + 4 * 3600000);
  }
  function addBusinessDays(start, n) {
    var d = new Date(start.getTime());
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 5 && wd !== 6) added++; /* Friday and Saturday are the weekend in Oman */
    }
    return d;
  }
  function initEta(root) {
    (root || document).querySelectorAll('[data-falaq-eta]').forEach(function (el) {
      if (el.dataset.ready) return;
      var min = parseInt(el.dataset.min, 10) || 2;
      var max = parseInt(el.dataset.max, 10) || 7;
      var loc = el.dataset.locale || 'en-GB';
      var now = muscatNow();
      var start = new Date(now.getTime());
      if (now.getHours() >= 15) start.setDate(start.getDate() + 1); /* after 3 pm it leaves the next day */
      var a = addBusinessDays(start, min);
      var b = addBusinessDays(start, max);
      var f;
      try { f = new Intl.DateTimeFormat(loc, { weekday: 'short', day: 'numeric', month: 'short' }); }
      catch (e) { f = new Intl.DateTimeFormat('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }); }
      var sep = loc.indexOf('ar') === 0 ? ' و ' : ' – ';
      el.querySelector('[data-eta-range]').textContent = f.format(a) + sep + f.format(b);
      el.hidden = false;
      el.dataset.ready = '1';
    });
  }
  function initSize(root) {
    (root || document).querySelectorAll('[data-falaq-sizehelp] select').forEach(function (sel) {
      if (sel.dataset.ready) return;
      sel.dataset.ready = '1';
      sel.addEventListener('change', function () {
        var v = sel.value;
        if (!v) return;
        var scope = sel.closest('.product__info-container, product-info, .product') || document;
        var input = Array.prototype.find.call(scope.querySelectorAll('input[type=radio]'), function (i) { return i.value === v; });
        if (input) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          var lab = scope.querySelector('label[for="' + input.id + '"]');
          if (lab) lab.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          return;
        }
        var opt = Array.prototype.find.call(scope.querySelectorAll('select option'), function (o) { return o.value === v && o.parentElement !== sel; });
        if (opt) { opt.parentElement.value = v; opt.parentElement.dispatchEvent(new Event('change', { bubbles: true })); }
      });
    });
  }
  function all(root) { initEta(root); initSize(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); });
  else all();
  /* Hyper re-renders product info on variant change and quick view */
  var t;
  new MutationObserver(function () {
    clearTimeout(t); t = setTimeout(all, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* Gift option in the cart: saved as cart attributes. */
if (!customElements.get('falaq-gift')) {
  customElements.define('falaq-gift', class extends HTMLElement {
    connectedCallback() {
      var self = this, box = this.querySelector('[data-gift-wrap]'), msg = this.querySelector('[data-gift-msg]'), t;
      function save() {
        var attrs = { 'Gift': box.checked ? 'Yes' : '', 'Gift wrap': '', 'Gift message': box.checked ? msg.value.trim() : '' };
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: attrs })
        }).catch(function () {});
      }
      box.addEventListener('change', function () {
        self.classList.toggle('is-open', box.checked);
        if (box.checked) setTimeout(function () { msg.focus(); }, 50);
        save();
      });
      msg.addEventListener('input', function () { clearTimeout(t); t = setTimeout(save, 500); });
      msg.addEventListener('blur', save);
    }
  });
}
